import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TaxiLanding from "@/pages/TaxiLanding";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<TaxiLanding />} />
                    <Route path="*" element={<TaxiLanding />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
